export default "__VITE_ASSET__BzzOg1b___"